
/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

export class UserModel {

  static TYPE_SPECTATOR = 0;
  static TYPE_DANCE_PARENT = 1;
  static TYPE_TEACHER = 2;
  static TYPE_DANCER = 3;
  static TYPE_OTHER = 4;

  constructor(public id: string, public email: string, public displayName: string, public postalCode: string, public accountType: number) {

  }

  static fromAngularFireSnapshot(snapshot) {
    const val: any = snapshot.payload.val();
    return new UserModel(snapshot.key, val.email, val.displayName, val.postalCode, val.acountType);
  }
}



// WEBPACK FOOTER //
// ./src/models/UserModel.ts